
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Wakadtomumbaicabservice() {



    const cardData =
    {
        keyword: 'Wakad to Mumbai Cab Service',
        heading: 'Meghana Cab : Wakad to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Wakad to Mumbai Cab Service, providing a dependable and comfortable travel option for residents, professionals, and families commuting from Pune’s bustling suburb to Mumbai. Whether you are heading for a business trip, vacation, or airport transfer, our wide range of vehicles—including Sedans, SUVs, Innova Crysta, and Tempo Travellers—ensures a smooth ride tailored to your needs. Enjoy doorstep pickup from Wakad, timely drop-offs, experienced drivers, and transparent pricing. Book your Wakad to Mumbai Cab with Meghana Cab for a hassle-free, safe, and enjoyable journey backed by 24/7 customer support.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
   
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Wakad to Mumbai Taxi Booking",
        "description": "Easily book your taxi from Wakad to Mumbai with our hassle-free booking system. We offer reliable and comfortable rides with experienced drivers, ensuring your journey is smooth whether for business or leisure."
    },
    {
        "name": "One Way Cab Wakad to Mumbai",
        "description": "Travel one way from Wakad to Mumbai with our efficient and punctual cab service. Ideal for airport transfers, meetings, or family visits, our one-way rides guarantee comfort and timely arrivals."
    },
    {
        "name": "Round Trip Wakad to Mumbai Cab",
        "description": "Plan your round trip taxi service between Wakad and Mumbai with flexible scheduling and affordable rates. Our round trip cabs are perfect for business travelers, tourists, and groups who prefer hassle-free return rides."
    },
    {
        "name": "Online Cab Wakad to Mumbai",
        "description": "Book your Wakad to Mumbai taxi online quickly and securely. Our easy-to-use platform provides instant confirmation, transparent pricing, and multiple vehicle options to suit your preferences and budget."
    },
    {
        "name": "Affordable Cab Wakad to Mumbai",
        "description": "Choose our budget-friendly cab service from Wakad to Mumbai that offers clean, safe vehicles without compromising on comfort. Perfect for travelers looking for affordable yet reliable transportation."
    },
    {
        "name": "AC Sedan Hire Wakad to Mumbai",
        "description": "Enjoy a cool and comfortable ride with our AC sedan hire from Wakad to Mumbai. Whether for corporate travel or personal trips, our sedans provide a smooth and stylish journey."
    },
    {
        "name": "SUV Taxi Wakad to Mumbai",
        "description": "Need extra space? Our SUV taxis from Wakad to Mumbai are ideal for larger groups or families. Spacious interiors, ample luggage capacity, and air conditioning ensure a pleasant trip."
    },
    {
        "name": "Budget Ride Wakad to Mumbai",
        "description": "Travel economically with our budget rides from Wakad to Mumbai. We offer competitive fares, reliable vehicles, and professional drivers, making long-distance travel affordable for all."
    },
    {
        "name": "Family Cab Wakad to Mumbai Trip",
        "description": "Make your family trip from Wakad to Mumbai comfortable and safe with our dedicated family cab service. Vehicles are spacious and well-maintained, with courteous drivers focused on passenger comfort."
    },
    {
        "name": "Chauffeur Driven Cab Wakad to Mumbai",
        "description": "Experience luxury and convenience with chauffeur-driven cabs from Wakad to Mumbai. Our professional drivers ensure a smooth, safe journey, perfect for executives and VIP travelers."
    },
    {
        "name": "Corporate Trip Wakad to Mumbai Taxi",
        "description": "Organize your corporate travel efficiently with our taxi services from Wakad to Mumbai. We provide timely pickups, professional service, and easy billing for business clients."
    },
    {
        "name": "Quick Travel Cab Wakad to Mumbai",
        "description": "In a hurry? Book our quick travel cab service from Wakad to Mumbai for prompt pickups and fast, hassle-free rides to your destination."
    },
    {
        "name": "Reliable Wakad to Mumbai Taxi",
        "description": "Count on our reliable taxi service for your journey from Wakad to Mumbai. With punctual drivers and well-maintained cars, we ensure stress-free travel every time."
    },
    {
        "name": "Private Cab Hire Wakad to Mumbai",
        "description": "Hire a private cab from Wakad to Mumbai for exclusive, personalized travel. Ideal for families, VIPs, and groups who prefer privacy and dedicated service."
    },
    {
        "name": "24/7 Cab Booking Wakad to Mumbai",
        "description": "Our 24/7 cab booking service from Wakad to Mumbai guarantees availability any time of day or night. Perfect for early morning flights, late-night returns, or urgent travel needs."
    }
],
"tableData": [
    ["Wakad to Mumbai Taxi Booking", "One Way Cab Wakad to Mumbai"],
    ["Round Trip Wakad to Mumbai Cab", "Online Cab Wakad to Mumbai"],
    ["Affordable Cab Wakad to Mumbai", "AC Sedan Hire Wakad to Mumbai"],
    ["SUV Taxi Wakad to Mumbai", "Budget Ride Wakad to Mumbai"],
    ["Family Cab Wakad to Mumbai Trip", "Chauffeur Driven Cab Wakad to Mumbai"],
    ["Corporate Trip Wakad to Mumbai Taxi", "Quick Travel Cab Wakad to Mumbai"],
    ["Reliable Wakad to Mumbai Taxi", "Private Cab Hire Wakad to Mumbai"],
    ["24/7 Cab Booking Wakad to Mumbai", ""]
],






"whychoose": [
    {
        "WhyChooseheading": "Trusted Wakad to Mumbai Cab Service",
        "WhyChoosedescription": "Our cab service from Wakad to Mumbai ensures dependable, timely, and professional transportation. Whether you're traveling for business, family, or airport transfers, we provide a smooth and convenient travel experience tailored to your schedule."
    },
    {
        "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Enjoy your ride in vehicles that are thoroughly cleaned, regularly serviced, and equipped with modern amenities like air-conditioning, plush seating, and sufficient luggage space for a stress-free journey."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are well-trained, polite, and familiar with the Wakad–Mumbai route. They follow all safety protocols and traffic regulations, ensuring your ride is not only fast but also secure and pleasant."
    },
    {
        "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
        "WhyChoosedescription": "Get competitive fares with 100% transparency. Our rates include all necessary costs such as tolls, fuel, driver allowance, and taxes—so you’ll never be surprised with additional charges."
    },
    {
        "WhyChooseheading": "Flexible Booking for One-Way and Round Trips",
        "WhyChoosedescription": "Book a one-way trip, round-trip, or hourly rental according to your travel needs. Our flexible service lets you schedule pickups and drop-offs at your preferred times and locations with ease."
    },
    {
        "WhyChooseheading": "Door-to-Door Pickup and Drop-off",
        "WhyChoosedescription": "No need to step out or look for pickup points—our cabs arrive right at your doorstep in Wakad and drop you off at your exact destination in Mumbai, making your trip completely hassle-free."
    },
    {
        "WhyChooseheading": "Ideal for Airport Transfers, Corporate Travel, and Personal Use",
        "WhyChoosedescription": "Whether you're heading to Mumbai International Airport, a corporate meeting, or a family event, our cab service is perfectly suited for every travel purpose with comfort and punctuality guaranteed."
    },
    {
        "WhyChooseheading": "24/7 Support and Easy Online Booking",
        "WhyChoosedescription": "Book your cab anytime via our user-friendly online system or with assistance from our 24/7 customer support team. We’re always available to help with bookings, rescheduling, or any travel-related queries."
    }
]






















    }

const faqData = [
    {
        question: "How can I book a cab from Wakad to Mumbai with Meghana Cab?",
        answer: "You can book your cab by calling +91 9075462128 or using our website for quick and secure booking."
    },
    {
        question: "What is the estimated travel time from Wakad to Mumbai by cab?",
        answer: "The journey typically takes around 3 to 4 hours, depending on traffic conditions."
    },
    {
        question: "Are one way and round trip cab services available from Wakad to Mumbai?",
        answer: "Yes, Meghana Cab offers both one way and round trip options to suit your travel needs."
    },
    {
        question: "What types of vehicles can I choose for Wakad to Mumbai cab service?",
        answer: "We provide a variety of vehicles including hatchbacks, sedans, SUVs, and tempo travellers."
    },
    {
        question: "Is the Wakad to Mumbai cab service available 24/7?",
        answer: "Yes, our services operate round the clock to accommodate your schedule."
    },
    {
        question: "Does the fare include tolls, fuel, and driver charges?",
        answer: "Yes, our fare covers fuel, tolls, and driver charges. Additional waiting or parking fees may apply."
    },
    {
        question: "Can I book a cab on short notice from Wakad to Mumbai?",
        answer: "Yes, last-minute bookings are accepted subject to vehicle availability. Please call for urgent requests."
    },
    {
        question: "Is online booking available for Wakad to Mumbai cab service?",
        answer: "Absolutely! You can book online anytime with instant confirmation and secure payment options."
    },
    {
        question: "Can I request stops during the journey for meals or breaks?",
        answer: "Yes, stops can be arranged on request. Please inform us while booking or notify the driver."
    },
    {
        question: "Are your drivers experienced and knowledgeable about the Wakad to Mumbai route?",
        answer: "Yes, our drivers are professional and well-acquainted with the best routes between Wakad and Mumbai."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Kiran Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab’s Wakad to Mumbai service was punctual and comfortable. The driver was courteous and the vehicle clean.”',
    },
    {
        name: 'Ms. Snehal Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Reliable cab service from Wakad to Mumbai with hassle-free online booking. Highly recommended!”',
    },
];





















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wakad to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/wakad-to-mumbai-cab.jpg",
  "description": "Book reliable and affordable cabs from Wakad to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and chauffeur-driven vehicles. Available for one-way and round trips with 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/wakad-to-mumbai-cab-service"
  }
};






    return (
        <div>

<Helmet>
  <title>Wakad to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Affordable and reliable cab service from Wakad to Mumbai by Meghana Cabs. Book AC Sedans, SUVs, or chauffeur-driven cars online. Available 24/7 for one-way and round trip travel." 
  />
  <meta 
    name="keywords" 
    content="Wakad to Mumbai Taxi Booking, One Way Cab Wakad to Mumbai, Round Trip Wakad to Mumbai Cab, Online Cab Wakad to Mumbai, Affordable Cab Wakad to Mumbai, AC Sedan Hire Wakad to Mumbai, SUV Taxi Wakad to Mumbai, Budget Ride Wakad to Mumbai, Family Cab Wakad to Mumbai Trip, Chauffeur Driven Cab Wakad to Mumbai, Corporate Trip Wakad to Mumbai Taxi, Quick Travel Cab Wakad to Mumbai, Reliable Wakad to Mumbai Taxi, Private Cab Hire Wakad to Mumbai, 24/7 Cab Booking Wakad to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/72.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Wakadtomumbaicabservice;